import { BarceloComponent } from "components-utils";

const VariousComponents = {
  languageDialog: BarceloComponent({
    selector: ".language-dialog-container-JS",
    path: "barcelo/various/language-dialog/js/c-language-dialog",
  }),

  currencyDialog: BarceloComponent({
    selector: ".currency-dialog-container-JS",
    path: "barcelo/various/currency-dialog/js/c-currency-dialog",
  }),

  opinion: BarceloComponent({
    selector: ".cmp-bhg-opinion",
    path: "barcelo/various/opinion/js/opinion",
  }),

  phoneContact: BarceloComponent({
    selector: ".bcom-phone-contact.c-phone-contact",
    path: "barcelo/various/phone-contact/js/phone-contact",
  }),

  socialRoom: BarceloComponent({
    selector: ".c-social-room",
    path: "barcelo/various/social-room/js/social-room",
  }),

  interactiveMap: BarceloComponent({
    selector: ".interactive-map, .c-interactive-map",
    path: "barcelo/various/interactive-map/js/interactive-map-new",
  }),

  customChrono: BarceloComponent({
    selector: ".custom-chrono-JS",
    path: "barcelo/various/custom-chrono/js/custom-chrono",
  }),

  countdown: BarceloComponent({
    selector: ".hide-countdown-JS, .promo-countdown-JS, [data-promo-countdown-to]",
    path: "barcelo/various/countdown/js/countdown",
  }),

  carouselExtras: BarceloComponent({
    selector: ".JS-carousel-extras-swiper",
    path: "barcelo/various/carousel-with-extras/js/carousel-with-extras",
    ignoreViewport: true,
  }),

  uspCampaignBanner: BarceloComponent({
    selector: ".usp-campaign-banner-wrapper-js",
    path: "barcelo/various/usp-campaign-banner/js/uspCampaignBanner",
  }),

  meetingForm: BarceloComponent({
    selector: ".c-meeting-form, [data-open-meeting-form]",
    path: "barcelo/various/meeting-form/js/meeting-form",
    ignoreViewport: true,
  }),

  meetComparatorCard: BarceloComponent({
    selector: ".meeting-comparator-card",
    path: "barcelo/various/meet-comparator-card/js/meet-comparator-card",
    ignoreViewport: true,
  }),

  uspNightsDetails: BarceloComponent({
    selector: ".usp-nights-details-dl-id",
    path: "barcelo/various/usp/js/usp-nights-details",
  }),

  moduleInfoCall: BarceloComponent({
    selector: ".c-module-info-call",
    path: "barcelo/various/module-info-call/js/c-module-info-call",
  }),

  premiumBanner: BarceloComponent({
    selector: ".premium-banner",
    path: "barcelo/various/premium-banner/js/premium-banner",
  }),

  appDownloadBanner: BarceloComponent({
    selector: ".c-app-download-banner",
    path: "barcelo/various/app-download-banner/js/app-download-banner",
    enableObserver: true,
    ignoreViewport: true,
  }),

  premiumServicesList: BarceloComponent({
    selector: ".premium-services-list",
    path: "barcelo/various/premium-services-list/js/premium-services-list",
  }),

  royalBanner: BarceloComponent({
    selector: ".c-royal-banner",
    path: "barcelo/various/royal-banner/js/royal-banner",
  }),

  servicesListEditorial: BarceloComponent({
    selector: ".services-list-editorial",
    path: "barcelo/various/services-list-editorial/js/services-list-editorial",
  }),

  regenImage: BarceloComponent({
    selector: ".regen-image-dl-id",
    path: "barcelo/various/regen-image/js/c-regen-image",
  }),

  centralImage: BarceloComponent({
    selector: ".central-image-dl-id",
    path: "barcelo/various/central-image/js/c-central-image",
  }),

  campaignChrono: BarceloComponent({
    selector: ".c-campaign-chrono.dynamicLoading",
    path: "barcelo/various/campaign-chrono/js/c-campaign-chrono",
  }),

  sectionHeadings: BarceloComponent({
    selector: ".c-section__headings",
    path: "barcelo/various/section-headings/js/section-headings",
  }),

  cardHotelHorizontal: BarceloComponent({
    selector: ".mod--horizontal-card",
    path: "barcelo/various/card-hotel-horizontal/js/card-hotel-horizontal",
  }),

  cardHotelDates: BarceloComponent({
    selector: ".c-card-dates",
    path: "barcelo/various/card-hotel-dates/js/card-hotel-dates",
  }),

  burger: BarceloComponent({
    selector: ".c-burger",
    path: "barcelo/various/burger/js/burger",
  }),

  scrollUp: BarceloComponent({
    selector: ".showOnScroll-JS",
    path: "barcelo/various/scroll-up/js/c-scroll-up",
    ignoreViewport: true,
  }),

  promoBannerCollect: BarceloComponent({
    selector: ".c-promo-banner-collect",
    path: "barcelo/various/promo-banner-collect/js/promo-banner-collect",
  }),

  campaignBanner: BarceloComponent({
    selector: ".campaign-banner-dl-id",
    path: "barcelo/various/campaign-banner/js/campaign-banner",
  }),
};

export default VariousComponents;
